export default {"src":"/_next/static/media/logo.84f59437.svg","height":1080,"width":1080,"blurWidth":0,"blurHeight":0};